import script from "./MainStepsTracker.vue?vue&type=script&setup=true&lang=js"
export * from "./MainStepsTracker.vue?vue&type=script&setup=true&lang=js"

import "./MainStepsTracker.vue?vue&type=style&index=0&id=4feea246&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4feea246"]])

export default __exports__